import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const axiosClient = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

// Process queued requests
const processQueue = (error) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

axiosClient.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and not retry yet
    if (error.response?.status === 401 && !originalRequest._retry) {

      if (isRefreshing) {
        // Wait until refresh finishes
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => {
          return axiosClient(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await axiosClient.post("/auth/refresh.php"); 
        // refresh endpoint should set new cookies

        processQueue(null);
        isRefreshing = false;

        return axiosClient(originalRequest); // retry original
      } catch (refreshError) {
        processQueue(refreshError);
        isRefreshing = false;

        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;